export enum DeleteAction {
  None = 0,
  All,
  One,
  AllWithLegacyReactivate
}
